import YogaTeachersPage from './YogaTeachersPage'

export default YogaTeachersPage
// eslint-disable-next-line import/export
export * from './YogaTeachersPage'
